import { ExternalLink } from "lucide-react";
import seal from "@/assets/fathergeek/seal.png";
import childGeek from "@/assets/fathergeek/child.jpg";
import parentGeek from "@/assets/fathergeek/parent.jpg";
import gamerGeek from "@/assets/fathergeek/gamer.jpg";

const REVIEW_URL = "https://fathergeek.com/order-of-the-blade/";

const groups = [
  {
    label: "Child Geeks",
    image: childGeek,
    quote:
      "This game is great! I like it because it reminds me a lot of the video games my mom only lets me play a little bit. But I can play this with my friends anytime I want!",
    verdict: "Child Geek Approved",
  },
  {
    label: "Parent Geeks",
    image: parentGeek,
    quote:
      "This game is fast, tactical, and above all, ruthless. Even if you are winning, you are always a target. I really enjoyed the change of pace this game provided!",
    verdict: "Parent Geek Approved",
  },
  {
    label: "Gamer Geeks",
    image: gamerGeek,
    quote:
      "Yes. Yes. Yes. This is a great example of a 'beer and pretzels' game I have so very much missed as of late… I really enjoyed it and would warmly welcome it back. Hell, I'm going to get my own copy!",
    verdict: "Gamer Geek Approved",
  },
];

const FatherGeekReview = () => {
  return (
    <section className="section-dark py-24 md:py-32 relative overflow-hidden border-t border-border">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="section-label">Professional Review</span>
            <h2 className="section-title text-dark-foreground mb-6">Father Geek Seal of Approval</h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Order of the Blade earned the official Father Geek Seal of Approval — winning over Child Geeks, Parent
              Geeks, and Gamer Geeks alike.
            </p>
            {/* CTA */}
            <div className="text-center mt-12">
              <a
                href={REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-blood-red uppercase tracking-[0.2em] text-sm font-semibold hover:text-dark-foreground transition-colors duration-300"
              >
                Read the full review on Father Geek
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Featured pull quote with seal */}
          <div className="grid lg:grid-cols-[auto_1fr] gap-10 lg:gap-14 items-center border border-border bg-[#0c0c0c] p-8 md:p-12 mb-8">
            <a
              href={REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block mx-auto lg:mx-0 transition-transform duration-500 hover:scale-105"
            >
              <img src={seal} alt="Father Geek Approved Seal" className="w-40 md:w-52 h-auto" />
            </a>
            <div>
              <span className="block text-blood-red font-serif leading-none mb-2" style={{ fontSize: "70px" }}>
                "
              </span>
              <blockquote className="text-xl md:text-2xl font-display text-card-foreground leading-relaxed italic -mt-6">
                Do play Order of the Blade the first chance you get. It was a great deal of fun for all of us and a game
                that will leave a positive — if not frustrated — impression on you and everyone you play it with.
              </blockquote>
              <p className="mt-6 text-muted-foreground text-sm font-semibold uppercase tracking-[0.2em]">
                — Cyrus, Father Geek
              </p>
            </div>
          </div>

          {/* Three geek group quotes */}
          <div className="grid md:grid-cols-3 gap-8">
            {groups.map((g) => (
              <div
                key={g.label}
                className="border border-border bg-[#0c0c0c] p-8 flex flex-col items-center text-center group transition-all duration-500 hover:-translate-y-1 hover:border-blood-red relative overflow-hidden"
              >
                <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-blood-red/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                {/* Quote circle icon */}
                <div className="mx-auto w-16 rounded-full flex items-center justify-center">
                  <span className="text-blood-red font-serif relative top-[15px]" style={{ fontSize: "70px" }}>
                    "
                  </span>
                </div>
                {/* <img src={g.image} alt={`${g.label} icon`} className="w-20 h-20 object-contain mb-4" /> */}
                <h3 className="text-lg font-display font-bold uppercase tracking-wide text-card-foreground mt-3 mb-3">
                  {g.label}
                </h3>
                <p className="text-muted-foreground leading-relaxed italic text-sm flex-1">"{g.quote}"</p>
                {/* <span className="mt-6 inline-flex items-center gap-2 text-blood-red text-xs uppercase tracking-[0.2em] font-semibold">
                  <span className="w-6 h-px bg-blood-red" />
                  {g.verdict}
                </span> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FatherGeekReview;
